export default "__VITE_ASSET__DbnnkEiy__"